const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        email: '',
        active: false
    }
});


// WEBPACK FOOTER //
// ./jiji/domain/entity/user.js